import { makePropSelector } from './common'
import { vendors } from './entities'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import * as R from 'ramda'

export let makePropertyVendorsSelector = () => createSelector(
    [vendors, makePropSelector('propertyID')]
  , (vendors, propertyId) => {
      return R.sortBy(R.prop('firstName'))(R.values(R.filter(vendor => {
          return ( vendor.propertyID == propertyId )
	  }, vendors)))
  }
)



// WEBPACK FOOTER //
// ./src/selectors/vendor.js